import Api from "./api.js";

/**
 * OneTrust — cookie consent, reached as `ThryvApi.oneTrust` on every page of both themes
 * (except error pages, which load no JS).
 *
 * READ-ONLY, AND ONLY CATEGORIES. This answers one question: what has the visitor agreed to. It
 * does not show the banner, change consent or delete cookies — OneTrust's own script owns all of
 * that, and legacy/js/onetrust/OneTrustWrapper_US.js handles the cookie clean-up it misses.
 *
 *   ThryvApi.oneTrust.optedIn();                     // [{ id, slug, name }, …]
 *   ThryvApi.oneTrust.optedIn("C0004");              // true / false
 *   ThryvApi.oneTrust.optedIn("targeting-cookies");  // same, matched by slug
 *   ThryvApi.oneTrust.optedIn("C0002", "C0004");     // true only if BOTH accepted
 *   ThryvApi.oneTrust.optedOut("C0004");             // the same four forms
 *   ThryvApi.oneTrust.categories();                  // every category, accepted or not
 *
 * PREFER IDS FOR GATING. Ids arrive with OneTrust's first signal; slugs need its full object, so a
 * slug match can be false for a moment where an id match is already true.
 *
 * NO LOADER, unlike the other members. OneTrust's script is loaded by the site itself and must run
 * before anything it gates — fetching it on demand would defeat the point.
 *
 * ── TIMING, WHICH IS THE WHOLE DIFFICULTY ────────────────────────────────────────────────────
 *
 * `OnetrustActiveGroups` does not exist until OneTrust has run, so a caller that asks too early
 * gets [] — which reads as "accepted nothing". That is deliberate: refusing to fire a tag you had
 * permission for is recoverable, firing one you did not is not.
 *
 * If you need to act the moment consent is known, wait for OneTrust rather than poll:
 *
 *   window.addEventListener("OneTrustGroupsUpdated", () => {
 *     if (ThryvApi.oneTrust.optedIn("C0004")) loadAdPixel();
 *   });
 *
 * That event also fires when the visitor CHANGES their mind, which is why nothing here caches.
 *
 * ── CATEGORY IDS ─────────────────────────────────────────────────────────────────────────────
 *
 * OneTrust's ids ("C0001", "C0002" …) are configured per domain, not fixed by the vendor, so there
 * is no id-to-name table here — `categories()` reads the names from OneTrust itself. Check the
 * OneTrust admin for what a given id means on this domain.
 */
export const OneTrust = {
  ...Api,

  /** Reached through ThryvApi.oneTrust; publishes no global, so there is nothing to do. */
  boot() {
    return this;
  },
};

export default OneTrust;
